import { Component, OnInit } from '@angular/core';
import { AdminServicesService } from '../../admin-services.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-add-leads-admin',
  templateUrl: './add-leads-admin.component.html',
  styleUrls: ['./add-leads-admin.component.css']
})
export class AddLeadsAdminComponent implements OnInit {

  public username:any;
  public dropdown:any=[];
  public mobile:any;
  public datafrom:any;
  public email:any;
  public role:any;
  public userId:any;
  constructor(public admin:AdminServicesService,
              public toastr:ToastrService,
              public router:Router ,private SpinnerService: NgxSpinnerService) { 
                let a = localStorage.getItem('userDetails');
                this.userId=JSON.parse(a);
              }

  ngOnInit(): void {
    this.SpinnerService.show();
    this.admin.referred().subscribe((res:any)=>
    {
      if(res.code===200)
      {
        this.SpinnerService.hide();
        this.dropdown=res.data;
      }
    },(err)=>
    {
      this.SpinnerService.hide();
      console.log(err);
    });
  }

  submit(){
    if(!this.username)
    {
      return this.toastr.error("User Name is Empty")
    }else if(!this.role)
    {
      return this.toastr.error("referredBy is Empty");
    }else if(!this.email)
    {
      return this.toastr.error("Email is Empty");
    }else if(!this.mobile)
    {
      return this.toastr.error("Mobile is Empty");
    }else if(!this.datafrom)
    {
      return this.toastr.error("DataFrom is Empty");
    }else {
      let obj = {
        "userName": this.username,
        "email": this.email,
        "dataFrom": this.datafrom,
        "referedBy": this.role,
        "mobileNum": this.mobile,
        "adminId": this.userId.userId
      }
      this.SpinnerService.show();
      this.admin.addlead(obj).subscribe((res:any)=>
      {
        this.SpinnerService.hide();
        if(res.code===200)
        {
          this.toastr.success("Added Successful");
          this.reset();

        }else {
          this.toastr.error("Failed");
        }
      },(err)=>
      {
        this.SpinnerService.hide();
        this.toastr.error("Failure");
        console.log(err);
      });
    }
  }
  reset(){
    this.username="";
    this.email="";
    this.mobile="";
    this.role="";
    this.datafrom="";
  }
}
